import React, {useContext} from "react";


class VscServerClient {

    constructor(private readonly serverUri:string) {

    }

    get(relativeUri:string) {
        return fetch(this.serverUri + relativeUri);
    }
    post(relativeUri:string, body: BodyInit|null|undefined, params?: RequestInit) {
        return fetch(this.serverUri + relativeUri, { method: 'POST', body: body, ...params});

    }
}

export const VscServerClientContext = React.createContext<VscServerClient|null>(null);

export function useVscServerClient() {
    return useContext(VscServerClientContext);
}
export default VscServerClient;
